
import { MessageType } from '@/types/assistant';
import { logger } from '@/utils/production-logger';

export class MessageValidationService {
  /**
   * Validate message before saving
   */
  static validateMessage(message: MessageType): { isValid: boolean; error?: string } {
    if (!message.id || !message.session_id || !message.user_id) {
      const error = 'Message validation failed - missing required fields';
      console.error('[VALIDATION] ' + error, {
        messageId: message.id || 'undefined',
        sessionId: message.session_id || 'undefined',
        userId: message.user_id || 'undefined'
      });
      logger.error(error, {
        messageId: message.id || 'undefined',
        sessionId: message.session_id || 'undefined',
        userId: message.user_id || 'undefined',
        component: 'MessageValidationService'
      });
      return { isValid: false, error };
    }

    return { isValid: true };
  }

  /**
   * Check if message should be skipped from saving
   */
  static shouldSkipSave(message: MessageType): boolean {
    if (message.is_streaming) {
      console.log('[VALIDATION] Skipping save for streaming message:', { messageId: message.id });
      logger.debug('Skipping save for streaming message', {
        messageId: message.id,
        component: 'MessageValidationService'
      });
      return true;
    }
    return false;
  }

  /**
   * Clean message data for database insertion - FIXED to preserve stream data
   */
  static cleanMessageData(message: MessageType): any {
    // FIXED: Preserve stream metadata for historical tracking
    const preserveStreamData = !message.is_streaming && (message.stream_content || message.stream_timestamp);
    
    console.log('[VALIDATION FIXED] Cleaning message data:', {
      messageId: message.id,
      isStreaming: message.is_streaming,
      hasStreamContent: !!message.stream_content,
      hasStreamTimestamp: !!message.stream_timestamp,
      willPreserveStreamData: preserveStreamData
    });

    return {
      id: message.id,
      session_id: message.session_id,
      user_id: message.user_id,
      role: message.role,
      content: message.content || '',
      suggestions: Array.isArray(message.suggestions) ? message.suggestions : [],
      is_streaming: false, // Always false for saved messages
      // FIXED: Preserve stream data for completed messages
      stream_content: preserveStreamData ? message.stream_content : null,
      stream_timestamp: preserveStreamData ? message.stream_timestamp?.toISOString() || null : null,
      model: message.model || 'gpt-4',
      feedback: message.feedback || null,
      metadata: message.metadata || {},
      created_at: message.timestamp?.toISOString() || new Date().toISOString(),
      updated_at: new Date().toISOString()
    };
  }
}
